var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "os-and-browser-wrapper" }, [
    _c("div", [
      _c("div", { staticClass: "os-and-browser" }, [
        _c("div", [
          _vm.getOS === "Windows"
            ? _c("span", [_c("windowsIcon")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.getOS === "Mac OS" ? _c("span", [_c("macIcon")], 1) : _vm._e(),
          _vm._v(" "),
          _vm.getOS === "Linux" ? _c("span", [_c("LinuxIcon")], 1) : _vm._e(),
          _vm._v(" "),
          _vm.getOS === "iOS" ? _c("span", [_c("iosIcon")], 1) : _vm._e(),
          _vm._v(" "),
          _vm.getOS === "Android"
            ? _c("span", [_c("androidIcon")], 1)
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                " + _vm._s(_vm.getOS) + "\n            "),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "os-and-browser" }, [
        _vm.getBrowser === "Chrome"
          ? _c("span", [_c("ChromeIcon")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getBrowser === "Safari"
          ? _c("span", [_c("SafariIcon")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getBrowser === "Edge" ? _c("span", [_c("EdgeIcon")], 1) : _vm._e(),
        _vm._v(" "),
        _vm.getBrowser === "Firefox"
          ? _c("span", [_c("FirefoxIcon")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.getBrowser === "Opera"
          ? _c("span", [_c("OperaIcon")], 1)
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(_vm.getBrowser) + " - " + _vm._s(_vm.getBrowserVersion)
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }